import { render, staticRenderFns } from "./DoucanPrivate.vue?vue&type=template&id=b332a1c8&scoped=true"
import script from "./DoucanPrivate.vue?vue&type=script&lang=js"
export * from "./DoucanPrivate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b332a1c8",
  null
  
)

export default component.exports